/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Playback_TitleInputs */

const vi_tracking_playback_title = /** @type {(inputs: Tracking_Playback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch sử hành trình`)
};

/**

* @param {Tracking_Playback_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_playback_title = /** @type {((inputs?: Tracking_Playback_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Playback_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_playback_title(inputs)
});